import React, { useState, useEffect, useRef } from "react";
import SimpleBar from "simplebar-react";
import { withNamespaces } from "react-i18next";
import axios from "axios";
import $ from "jquery";
import ReactLoading from "react-loading";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import GruppenpreiseEdit from "./Gruppenpreise_edit.js";

const Gruppenpreise = (props) => {
    let [preise, setPreise] = useState([]);
    let [loaderShow, setLoaderShow] = useState(false);

    const activeRights = JSON.parse(localStorage.getItem("rights"));
    const link = "/api/CustomLogic";

    const [popUpShow, setPopUpShow] = useState(false);
    const [currentEditData, setCurrentEditData] = useState();
    const popUpContainer = useRef(null);
    const euroNumberFormat = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
        loadData();
    }, [localStorage.getItem("JWT")]);

    $(document).on("click", function (e) {
        if (
            popUpContainer.current &&
            !popUpContainer.current.contains(e.target) &&
            e.target.id != "settings-icon" &&
            !$(e.target).is(".settings-item") &&
            !$(e.target).children().hasClass("settings-item") &&
            !$(e.target).hasClass("select-icon") &&
            !$(e.target).parents(".rc-time-picker-panel").length == 1 &&
            !$(e.target).hasClass("rc-time-picker-clear") &&
            !$(e.target).hasClass("rc-time-picker-clear-icon") &&
            e.target.id != "pop-up-button"
        ) {
            setPopUpShow(false);
        }
    });

    const loadData = () => {
        if (!activeRights.includes("Gruppenpreise.Get")) {
            return;
        }
        setLoaderShow(true);

        axios.get(link + "/Preise/Gruppenpreis", {}).then((response) => {
            {/*
            setPreise([
                { gruppennummer: 1, gruppenname: "Test1", preisProTag: 12.1 },
                { gruppennummer: 2, gruppenname: "Test2", preisProTag: 12.2 },
                { gruppennummer: 3, gruppenname: "Test3", preisProTag: 12.3 },
                { gruppennummer: 4, gruppenname: "Test4", preisProTag: 12.4 },
                { gruppennummer: 5, gruppenname: "Test5", preisProTag: 12.5 },
                { gruppennummer: 6, gruppenname: "Test6", preisProTag: 12.6 },
            ]);
            */}
            setPreise(response.data);
            setLoaderShow(false);
        })
            .catch((error) => {
                console.error("Error while loading Data", error);
                setLoaderShow(false);
            })
            ;
    }

    const editCreateEntry = (entry) => {
        setCurrentEditData(entry);
        setPopUpShow(true);
        // TODO: Es gefällt mir nicht, hier erst setCurrentDings aufzurufen. Kann man setPopUpShow(true, entry) machen?
    }

    const deleteEntry = (entry) => {
        if (!activeRights.includes("Gruppenpreise.Delete")) {
            return;
        }
        console.debug("Entry %o want to be deleted", entry);

        confirmAlert({
            message: "Der Eintrag '" + entry.gruppennummer + "' - '" + entry.gruppenname + "' wird gelöscht.",
            buttons: [
                {
                    label: props.t("allgemein.ja"),
                    onClick: () =>
                        axios.delete(link + "/Preise/Gruppenpreis", {
                            data: entry.id,
                            headers: {
                                "Content-Type": "application/json",
                            },
                        })
                            .then((response) => {
                                loadData();
                            })
                            .catch((error) => { console.error("Error while deleting Entry", error); }),
                },
                {
                    label: props.t("allgemein.nein"),
                },
            ],
        });
    };

    function getHtmlList() {
        let htmlList = [];

        for (let i = 0; i < preise.length; i++) {
            let preis = preise[i];

            htmlList.push(
                <tr>
                    <td>{preis.gruppennummer}</td>
                    <td>{preis.gruppenname}</td>
                    <td>{euroNumberFormat.format(preis.preisProTag)}</td>
                    <td>
                        {activeRights.includes("Gruppenpreise.Update") && (
                            <button
                                className="button"
                                id="pop-up-button"
                                style={{ width: "80px" }}
                                onClick={() => editCreateEntry(preis)}
                            >
                                {props.t("allgemein.Bearbeiten")}
                            </button>)
                        }

                        {activeRights.includes("Gruppenpreise.Delete") && (
                            <button
                                className="button"
                                id="pop-up-button"
                                style={{ width: "80px", marginLeft: "10px" }}
                                onClick={() => deleteEntry(preis)}
                            >
                                {props.t("allgemein.Loeschen")}
                            </button>)
                        }
                    </td>
                </tr>
            );
        }

        return <tbody>{htmlList}</tbody>;
    }

    return (
        <div>
            {popUpShow == true && (
                <div ref={popUpContainer}>
                    {
                        <GruppenpreiseEdit
                            data={currentEditData}
                            onChange={() => { setPopUpShow(false); loadData(); }}
                        >
                            {" "}
                        </GruppenpreiseEdit>
                    }
                </div>
            )}

            <div className="einstellungen-box">
                <div className="box-name">Gruppenpreise</div>
                <div style={{ overflow: "auto" }}>
                    {loaderShow == true && (
                        <div style={{ position: "absolute" }}>
                            <ReactLoading
                                type={"bars"}
                                color={"#2a3042"}
                                height={80}
                                width={80}
                                name={"Loading"}
                            />
                        </div>
                    )}

                    <table id="dataTable">
                        <thead>
                            <tr>
                                <th style={{ textAlign: "center" }}>Gruppennummer</th>
                                <th style={{ textAlign: "center" }}>Name</th>
                                <th style={{ textAlign: "center" }}>Preis pro Tag</th>
                                <th style={{ textAlign: "right" }}>
                                    {activeRights.includes("Gruppenpreise.Create") && (
                                        <button className="button" id="pop-up-button" style={{ width: "50px" }} onClick={() => editCreateEntry()}>
                                            {props.t("allgemein.neu")}
                                        </button>)
                                    }
                                </th>
                            </tr>
                        </thead>
                        {getHtmlList()}
                    </table>
                </div>
            </div>
        </div>
    );
};

export default withNamespaces()(Gruppenpreise);
